var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "h-full" }, [
    _c("div", { staticClass: "h-full flex flex-col gap-y-2 lg:gap-y-4" }, [
      _c("div", [
        _c(
          "div",
          {
            staticClass:
              "flex justify-between items-center flex-wrap gap-2 relative lg:gap-3",
          },
          [
            _c(
              "div",
              { staticClass: "w-full flex justify-center lg:absolute" },
              [
                _c("GrmSearch", {
                  ref: "search",
                  staticClass: "w-full lg:w-60",
                  attrs: { value: _vm.testbankExamListFilter.searchText },
                  on: {
                    input: (value) =>
                      _vm.SET_TESTBANK_EXAM_LIST_FILTER({ searchText: value }),
                    clear: () => {
                      _vm.SET_TESTBANK_EXAM_LIST_FILTER({ searchText: "" })
                      _vm.$refs.search.$refs.search.focus()
                    },
                  },
                }),
              ],
              1
            ),
            _c("ul", { staticClass: "flex items-center gap-x-2" }, [
              _c(
                "li",
                [
                  _c("GrmSimpleSelect", {
                    attrs: {
                      value: _vm.testbankExamListFilter.size,
                      options: [
                        { value: 10, title: _vm.$t("common.table.count.ten") },
                        {
                          value: 20,
                          title: _vm.$t("common.table.count.twenty"),
                        },
                        {
                          value: 30,
                          title: _vm.$t("common.table.count.thirty"),
                        },
                        {
                          value: 40,
                          title: _vm.$t("common.table.count.forty"),
                        },
                        {
                          value: 50,
                          title: _vm.$t("common.table.count.fifty"),
                        },
                      ],
                    },
                    on: {
                      input: (value) =>
                        _vm.SET_TESTBANK_EXAM_LIST_FILTER({ size: value }),
                    },
                  }),
                ],
                1
              ),
            ]),
            _c(
              "div",
              { staticClass: "flex items-center gap-x-1 relative" },
              [
                _c(
                  "GrmBtn",
                  {
                    attrs: { color: "gray" },
                    on: {
                      click: function ($event) {
                        return _vm.SET_VIEW("testbank__list")
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("testBank.goBack")))]
                ),
                _c("GrmBtn", { on: { click: _vm.onCreateTestbank } }, [
                  _vm._v(_vm._s(_vm.$t("testBank.regPaper"))),
                ]),
              ],
              1
            ),
          ]
        ),
      ]),
      _c(
        "div",
        { staticClass: "min-h-0 flex-1" },
        [_c("RoomTestbankExamTable")],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }